import React from "react";
import ReactPlayer from "react-player/lazy";

export const VideoPlayer = ({ url = "", autoPlay = false, controls = true, ...rest }) => {
  return <ReactPlayer url={url} playing={autoPlay} controls={controls} {...rest} />;
};
